import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

// Demo shipments are browse-only: mutating actions show this hint instead.
export const useDemoHint = () => {
  const { t } = useTranslation("common");

  return useCallback(
    () =>
      toast.info(t("parcels.demo.actionHint"), {
        toastId: "demo-action-hint",
        icon: false,
      }),
    [t],
  );
};
